export function GetData(type, token) {
    const cookieDataReplace = document.cookie.split('; ').find((row) => row.startsWith('mokhasanLogin='))
    let sessionData = null;
    if(cookieDataReplace) {
        sessionData = JSON.parse(cookieDataReplace.replace('mokhasanLogin=', ''));
    }
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'POST',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionData ? sessionData[0]?.token || "" : ""}`
            },
        };
        fetch("/api/" + type, requestOptions)
            .then((response) => response.json())
            .then((responseJSON) => {
                resolve(responseJSON)
            })
            .catch((error) => {
                reject(error)
            })
    })
}